import apiClient from '../axios.js'

/**
 * 方案管理 API
 */
export const planService = {
    /**
     * 獲取方案列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁數量
     * @param {string} params.search - 搜尋關鍵字
     * @param {string} params.planType - 方案類型（可選）
     * @param {string} params.status - 狀態（可選）
     * @returns {Promise<Object>} 方案列表
     */
    getPlans: async (params = {}) => {
        const response = await apiClient.get('/system/plans', { params })
        return response
    },

    /**
     * 獲取單一方案詳情
     * @param {string} id - 方案 ID
     * @returns {Promise<Object>} 方案詳情
     */
    getPlan: async (id) => {
        const response = await apiClient.get(`/system/plans/${id}`)
        return response
    },

    /**
     * 檢查方案代碼是否可用
     * @param {string} planCode - 方案代碼
     * @returns {Promise<Object>} 檢查結果 { exists, available }
     */
    checkPlanCode: async (planCode) => {
        const response = await apiClient.get(`/system/plans/check/${planCode}`)
        return response
    },

    /**
     * 新增方案
     * @param {Object} planData - 方案資料
     * @returns {Promise<Object>} 新增結果
     */
    createPlan: async (planData) => {
        const response = await apiClient.post('/system/plans', planData)
        return response
    },

    /**
     * 更新方案
     * @param {string} id - 方案 ID
     * @param {Object} planData - 方案資料
     * @returns {Promise<Object>} 更新結果
     */
    updatePlan: async (id, planData) => {
        const response = await apiClient.put(`/system/plans/${id}`, planData)
        return response
    },

    /**
     * 刪除方案
     * @param {string} id - 方案 ID
     * @returns {Promise<Object>} 刪除結果
     */
    deletePlan: async (id) => {
        const response = await apiClient.delete(`/system/plans/${id}`)
        return response
    },
}
